<div
  chPaidOverlay
  [ctaText]="'Exchange messages securely, outside cluttered email inboxes'"
  [ctaVideo]="'https://youtu.be/sLHczh9jVDA'"
></div>

<div class="ch-panel-content-no-scroll">
  <div class="ch-tabs" style="margin: 0 15px">
    <div [ngClass]="{ active: showChat }" (click)="switchChatTabs('chat')">
      Messages
    </div>
    <div [ngClass]="{ active: showFiles }" (click)="switchChatTabs('files')">
      Recent Files
    </div>
  </div>
</div>

<!-- Chat -->
<chat
  class="ch-panel-content-wrapper"
  [style.display]="showChat ? 'flex' : 'none'"
>
</chat>

<!-- Recent Files -->
@if (showFiles == true) {
<app-recent-files
  class="ch-panel-content-wrapper"
  style="padding: 0 15px; background: #f6f7f9"
  [conversation]="conversation"
  [style.display]="showFiles ? 'flex' : 'none'"
></app-recent-files>
}

<ng-template filePreview></ng-template>
